import React from "react";
import Grid from "@mui/material/Grid2";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { alpha } from "@mui/material/styles";
import { fpColors } from "../../../theme/fpTheme.ts";

// Components/widgets
import ApplicationsWidget from "../widgets/ApplicationsWidget.tsx";
// import MetricPendingOrdersWidget from "../widgets/MetricPendingOrdersWidget.tsx";
// import MetricExpiringQuotesWidget from "../widgets/MetricExpiringQuotesWidget.tsx";
// import MetricLoadsShippingWidget from "../widgets/MetricLoadsShippingWidget.tsx";
// import MetricLoadsInTransitWidget from "../widgets/MetricLoadsInTransitWidget.tsx";
// import MetricCurrentAccrualWidget from "../widgets/MetricCurrentAccrualWidget.tsx";
// import MetricOutstandingInvoicesWidget from "../widgets/MetricOutstandingInvoicesWidget.tsx";
// import MetricDeliveryPerformanceWidget from "../widgets/MetricDeliveryPerformanceWidget.tsx";
// import MetricCostPerLBWidget from "../widgets/MetricCostPerLBWidget.tsx";
import WelcomeCardWidget from "../widgets/WelcomeCardWidget.tsx";

// Wrap Responsive with WidthProvider and cast so TS accepts it as a JSX component
const GridLayout = WidthProvider(
  Responsive,
) as unknown as React.ComponentType<any>;

// Define layout for initial widget positions
// Note: `x` is the 0-based starting column index and `w` is the width in columns.
//       The grid's column count for the lg breakpoint is cols.lg = 15 (see GridLayout cols).
//       An item occupies columns [x, x + w - 1]. Therefore x + w must be <= cols.
//       Example: x = 12, w = 3 => occupies columns 12,13,14 (x + w = 15) which fits within 15 columns.
//
//       Be careful when using responsive layouts: for smaller breakpoints (md/sm/xs) the
//       cols count is smaller (e.g. md:12, sm:8, xs:4). You should supply corresponding
//       layouts for those breakpoints or the grid will reposition/stack items automatically.
const initialLayout = [
  // // === Column 1 (x = 0 → 3 units wide) ===
  // { i: "MetricOrderPendingSubmission", x: 0, y: 0, w: 3, h: 2 },
  // { i: "MetricLoadsShipping", x: 0, y: 2, w: 3, h: 2 },
  // { i: "MetricInvoiceCurrentAccrual", x: 0, y: 4, w: 3, h: 2 },

  // // === Column 2 (x = 3 → 3 units wide) ===
  // { i: "MetricQuotesExpiringToday", x: 3, y: 0, w: 3, h: 2 },
  // { i: "MetricLoadsInTransit", x: 3, y: 2, w: 3, h: 2 },
  // { i: "MetricInvoiceOutstandingInvoices", x: 3, y: 4, w: 3, h: 2 },

  // // === Column 3 (x = 6 → 3 units wide) ===
  // { i: "MetricShipmentDeliveryPerformance", x: 6, y: 0, w: 6, h: 6 },
  // { i: "MetricItemCostPerLB", x: 6, y: 6, w: 6, h: 6 },

  // === Column 4 (x = 9 → 3 units wide) ===
  { i: "ApplicationsCard", x: 12, y: 0, w: 3, h: 6 },
  { i: "WelcomeCard", x: 12, y: 6, w: 3, h: 2 },
];

// Provide the same layout for the lg breakpoint; copy/adapt for other breakpoints if needed.
const layouts = { lg: initialLayout };

const MainGrid = () => {
  return (
    <Grid
      sx={{
        width: "100%",
        maxWidth: 1800,
        height: "auto", // let content determine height
        // make the grid fill the remaining viewport under the header (main has mt: '70px')
        minHeight: "calc(100vh - 70px)",
        position: "relative",
        overflow: "hidden", // let the page (browser) handle scrolling; avoid nested scrollbars
        overflowX: "hidden", // prevent accidental horizontal scroll
        // backgroundColor: fpColors.fplightblue, // ✅ full background color
        // "&:before": {
        //   content: '""',
        //   position: "absolute",
        //   top: 0,
        //   left: "50%",
        //   transform: "translateX(-50%)",
        //   width: "60%",
        //   height: "200px",
        //   background: `radial-gradient(ellipse at center, ${alpha(fpColors.fpgreen, 0.10)} 0%, transparent 70%)`,
        //   pointerEvents: "none",
        //   zIndex: 0,
        // },
      }}
    >
      <GridLayout
        isDraggable={false}
        isResizable={false}
        useCSSTransforms
        className="layout"
        layouts={layouts as any}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
        cols={{ lg: 15, md: 12, sm: 8, xs: 4 }}
        rowHeight={40} // Reduced rowHeight to fit more in view
        margin={[12, 12]} // Smaller margins
        containerPadding={[2, 8]} // Smaller padding
      >
        {/* === Metrics Info Cards === */}
        {/* <div key="MetricOrderPendingSubmission">
          <MetricPendingOrdersWidget />
        </div>
        <div key="MetricQuotesExpiringToday">
          <MetricExpiringQuotesWidget />
        </div>
        <div key="MetricLoadsShipping">
          <MetricLoadsShippingWidget />
        </div>
        <div key="MetricLoadsInTransit">
          <MetricLoadsInTransitWidget />
        </div>
        <div key="MetricInvoiceCurrentAccrual">
          <MetricCurrentAccrualWidget />
        </div>
        <div key="MetricInvoiceOutstandingInvoices">
          <MetricOutstandingInvoicesWidget />
        </div> */}

        {/* === Charts === */}
        {/* <div key="MetricItemCostPerLB">
          <MetricCostPerLBWidget />
        </div>
        <div key="MetricShipmentDeliveryPerformance">
          <MetricDeliveryPerformanceWidget />
        </div> */}

        {/* === Right-side placeholders === */}
        <div key="ApplicationsCard">
          <ApplicationsWidget />
        </div>
        <div key="WelcomeCard">
          <WelcomeCardWidget />
        </div>
      </GridLayout>
    </Grid>
  );
};

export default MainGrid;
